import { api } from "./api";

export const BankAdd = async (data) => {
  return api.post("business/add/bank", data);
};
export const BankUpdate = async (data) => {
  return api.post("business/update/bank", data);
};
export const BankDelete = async (id) => {
  return api.post(`business/delete/bank?id=${id}`);
};
export const BankList = async (data) => {
  return api.get("business/bank/list", data);
};

export const BankTransactions = async (params) => {
  return api.get("business/bank/transactions", { params });
};

// Fund transfer

export const BankMoneyTransfer = async (data) => {
  return await api.post(`bank/transactions/add`, data);
};

export const BankTransferList = async (addUrl) => {
  let url = `bank/transactions/list?${addUrl}`;
  return await api.get(url);
};

export const appBankStatusUpdate = async (data) => {
  return api.post("/business/update/bank/app/status", data);
};
